import { useState, useRef } from 'react';
import './Calculator.css';
import { FormControl, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import { withStyles } from '@material-ui/core/styles';
import IntroductionPage from '../pages/introduction';
import FirstFitterPage from '../pages/first';
import SecondFitterPage from '../pages/second';
import { calculateBraSize } from '../utils';
import { range } from '../utils';
import CloseIcon from '@mui/icons-material/Close';
import rules from '../validationRules';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

function Calculator({ onClose }) {
	const [fitterPage, setFitterPage] = useState(1);
	const [calculatedSizeText, setCalculatedSizeText] = useState({});

	const [firstPageValues, setFirstPageValues] = useState({
		leftBreast: '',
		rightBreast: '',
		bandSize: ''
	});
	const [secondPageValues, setSecondPageValues] = useState({
		age: '',
		underwear: '',
		currentBrands: ''
	});
	const [errors, setErrors] = useState({
		leftBreast: '',
		rightBreast: '',
		bandSize: ''
	});
	const [isSubmitted, setIsSubmitted] = useState(false);
	const [finalBraSize, setfinalBraSize] = useState({});

	const BootStrapButton = withStyles({
		root: {
			border: '1px solid black',
			padding: '7px 20px',
			letterSpacing: '2px',
			'&:hover': {
				boxShadow: '0px 0px 0px 1px black'
			}
		}
	})(Button);

	const handleChange = (prop) => (event) => {
		if (prop in firstPageValues) {
			setFirstPageValues({
				...firstPageValues,
				[prop]: event.target.value
			});
		} else {
			setSecondPageValues({
				...secondPageValues,
				[prop]: event.target.value
			});
		}
	};

	const validateBraValues = (values) => {
		let hasErrors;
		for (const v in values) {
			let isInRange;
			// const isInRange = cupRange.includes(parseInt(values[v], 10));
			if (v === 'bandSize') {
				const bandRange = range(
					rules.band.range[0],
					rules.band.range[1]
				);

				isInRange = bandRange.includes(parseInt(values[v], 10));
			} else {
				const cupRange = range(
					rules.cups.range[0],
					rules.cups.range[1]
				);
				isInRange = cupRange.includes(parseInt(values[v], 10));
			}

			if (values[v] === '') {
				//todo band validation

				hasErrors = true;
				setErrors((prevState) => ({
					...prevState,
					[v]: window.bra_calc_str.add_measurment
				}));
			} else if (!isInRange) {
				hasErrors = true;

				setErrors((prevState) => ({
					...prevState,
					[v]: window.bra_calc_str.out_of_range
				}));
			} else {
				setErrors((prevState) => ({ ...prevState, [v]: '' }));
			}
		}

		return hasErrors;
	};

	const validateForNotEmpty = (values) => {
		let hasErrors;
		for (const v in values) {
			if (values[v] === '') {
				hasErrors = true;
				setErrors((prevState) => ({
					...prevState,
					[v]: window.bra_calc_str.add_input
				}));
			} else {
				setErrors((prevState) => ({ ...prevState, [v]: '' }));
			}
		}

		return hasErrors;
	};

	const handleNext = () => {
		const hasErrors = validateBraValues(firstPageValues);

		if (hasErrors) {
			return;
		}
		setFitterPage(2);
	};

	const postToServer = (braSize) => {
		const date = new Date();
		const myData = {
			...firstPageValues,
			...secondPageValues,
			size: braSize,
			id: 'DATETIME'
		};
		fetch('https://sheetdb.io/api/v1/i06fjdzbv3xbz', {
			method: 'POST',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				data: [myData]
			})
		})
			.then((response) => response.json())
			.then((data) => console.log(data));
	};

	const postToKlaviyo = (event) => {
		event.preventDefault();
		
		setIsSubmitted(true);

		const braData = {
			...firstPageValues,
			...secondPageValues,
			size: finalBraSize
		};

		let email = document.getElementById('klaviyo-email').value;
		const options = {
			method: 'POST',
			headers: {revision: '2024-02-15', 'content-type': 'application/json'},
			body: JSON.stringify({
			  data: {
				type: 'subscription',
				attributes: {
					profile: {
						data: {
							type: 'profile',
							attributes: {
								email: email,
								properties: braData
							}
						}
					}
				},
				relationships: {list: {data: {type: 'list', id: 'VTEeBm'}}}
			  }
			})
		};

		fetch('https://a.klaviyo.com/client/subscriptions/?company_id=VLzDhf', options)
		.then(response => setIsSubmitted(true))
		.catch(err => console.error(err));
	};

	const handleSubmit = async () => {
		const hasErrors = validateForNotEmpty(secondPageValues);

		if (hasErrors) {
			return;
		}

		const size = calculateBraSize(firstPageValues);
		const finalSize = `${size.regularSize} ${size.paddingCup}`;
		setfinalBraSize(finalSize);
		postToServer(finalSize);

		let variantId = getProductVariantId(size.regularSize, size.paddingCup);

		if (!size || !size.regularSize || !size.paddingCup || size.tooAsym || !variantId) {
			setCalculatedSizeText({
				unavailable: true,
				text: window.bra_calc_str.not_supported,
			});
			setFitterPage(3);
		} else {
			const text = `${size.regularSize} ${size.paddingCup}`;

			setCalculatedSizeText({ text: text, variantId: variantId });
			setFitterPage(3);
		}
	};

	const handleBack = () => {
		setFitterPage(1);
	};

	const getProductVariantId = (regularSize, paddingCup) => {

		if( typeof window.bra_product === "undefined" ){
			return false
		}

		for( var i = 0; i < window.bra_product.variants.length; i++){
			if(window.bra_product.variants[i].option1 == regularSize && window.bra_product.variants[i].option2 == paddingCup){
				return window.bra_product.variants[i].id;
			}
		}

		return false;
	};

	const handleShop = () => {
		onClose ? onClose() : null;

		if(calculatedSizeText.variantId){
			window.location.href = window.location.origin + window.bra_url + "?variant=" + calculatedSizeText.variantId;
			return;
		}

		const currentLocation = window.location.pathname;
		const desiredLocation = `/products/basic-bra`;
		if (currentLocation === desiredLocation) {
			return;
		}
		window.location.pathname = desiredLocation;
	};

	const finalSize = () => {
		if (calculatedSizeText.unavailable) {
			
			if (isSubmitted) {

				return (
					<div>
						<Typography variant="h3"><span dangerouslySetInnerHTML={{ __html: window.bra_calc_str.subscribed_title }}></span></Typography>
						<div className="Form-wrapper__end-desc" dangerouslySetInnerHTML={{ __html: window.bra_calc_str.subscribed_content_html }}>
						</div>
						<a href={ window.bra_calc_str.subscribed_url } className="button button--full-width">{ window.bra_calc_str.subscribed_cta }</a>
					</div>
				);
			}

			return (
				<div>
					<Typography variant="h3"><span dangerouslySetInnerHTML={{ __html: window.bra_calc_str.out_of_stock_html }}></span></Typography>
					<div className="Form-wrapper__end-desc">
						{ window.bra_calc_str.out_of_stock_desc }
					</div>
					
					<form onSubmit={postToKlaviyo}>
						<div>
							<input
								type="email"
								id="klaviyo-email"
								placeholder={ window.bra_calc_str.email }
								name="EMAIL"
								required=""
								className="custom-email-input"
							/>
						</div>
						<button className="button button--full-width">{ window.bra_calc_str.submit }</button>
					</form>
				</div>
			);
		}

		return (
			<>
				<Typography variant="h3">{ window.bra_calc_str.calc_size } <strong>{calculatedSizeText.text}</strong></Typography>
				<div className="Form-wrapper__end-desc Form-wrapper__end-light" dangerouslySetInnerHTML={{ __html: window.bra_calc_str.calc_desc_html }}>
				</div>
				<button className="button button--full-width" onClick={handleShop}>{ window.bra_calc_str.shop_now }</button>
				<a href="#newBcalc" className="Form-wrapper__retry" onClick={handleBack}>{ window.bra_calc_str.new_calc }</a>
			</>
		);
	};

	return (
		<div className="Form-wrapper">
			<div className="Form-wrapper__header">
				{fitterPage !== 1 ? (
					<ArrowBackIcon onClick={handleBack}></ArrowBackIcon>
				) : (
					<span />
				)}
				{!!onClose ? <CloseIcon onClick={onClose} /> : <span />}
			</div>

			<div className="Form-wrapper__inner">
				<FormControl component="fieldset">
					{fitterPage === 1 && (
						<FirstFitterPage
							values={firstPageValues}
							errors={errors}
							handleChange={handleChange}
						/>
					)}
					{fitterPage === 2 && (
						<SecondFitterPage
							values={secondPageValues}
							errors={errors}
							handleChange={handleChange}
							handleBackCb={handleBack}
						/>
					)}
					{fitterPage === 3 && (
						<div className="Form-wrapper__end">{finalSize()}</div>
					)}
				</FormControl>
			</div>

			{fitterPage === 1 && (
				<div>
					<BootStrapButton
						variant="outlined"
						color="secondary"
						onClick={handleNext}
					>
						{ window.bra_calc_str.next }
					</BootStrapButton>
				</div>
			)}

			{fitterPage === 2 && (
				<div>
					<BootStrapButton
						variant="outlined"
						color="secondary"
						onClick={handleSubmit}
					>
						{ window.bra_calc_str.submit }
					</BootStrapButton>
				</div>
			)}

		</div>
	);
}

export default Calculator;
